import React from "react";

const Pages = ({start, finish, pages, toPage, sectionObject, children}) => {
    const FirstPage = ({start}) => {
        if(start >= 3) {
            return (
                <>
                    <button className="page firstPage" onClick={()=>toPage(sectionObject, 1)}>1</button>
                    <span>...</span>
                </>
            )
        }
    };

    const LastPage = ({finish, pages}) => {
        if(finish <= pages - 2) {
            return (
                <>
                    <span>...</span>
                    <button className="page lastPage" onClick={()=>toPage(sectionObject, pages)}>{pages}</button>
                </>
            )
        }
    };

    return (
        <React.StrictMode>
            <FirstPage start={start} />
            {children}
            <LastPage finish={finish} pages={pages} />
        </React.StrictMode>
    );
};

export default function ListPagination({sectionObject, currentPage, pages, prevPage, toPage, nextPage, isLoading = false}) {
    const maxItems = 8;
    
    let start = currentPage - maxItems / 2 + 1;
    if (start <= 2) {
        start = 1;
    } else if (start > pages - maxItems + 2) {
        start = pages - maxItems + 2;
    }

    let finish = start + maxItems - 2;
    if (finish > pages - 2) {
        finish = pages;
    }

    function PageButtons({start,finish, currentPage, toPage, sectionObject}) {
        const pages = [];
        for (let i = start; i <= finish; i++) {
            const active = (i === currentPage) ? 'active' : '';
            pages.push(
                <button key={`pageBtn${i}`} className={`page ${active}`} onClick={()=>toPage(sectionObject, i)}>{i}</button>
            );
        }

        // console.log(pages, start, finish, currentPage);
        return <>{pages}</>;
    }

    return(
        <React.StrictMode>
            <button className="prev" onClick={()=>prevPage(sectionObject)}></button>
            <nav className="pages">
                <Pages start={start} finish={finish} currentPage={currentPage} pages={pages} toPage={toPage} sectionObject={sectionObject}>
                    <PageButtons start={start} finish={finish} currentPage={currentPage} toPage={toPage} sectionObject={sectionObject} />
                </Pages>
            </nav>
            <button className="next" onClick={()=>nextPage(sectionObject)}></button>
        </React.StrictMode>
    )
}